module.exports = __webpack_public_path__ + "img/de-praktijk-5.e61c1f01.jpg";